import { loginAxios } from "@/utils/axios";
import { store } from "@/store";
export const loginService = {
  login(body = {}) {
    return loginAxios.post(
      "/index.php?c=port&m=actionGet_Android_v2_Port&module=Weixin&opt=login_app",
      { ...body, open_id: store.state.openId, code: store.state.code }
    );
  },
  login2(body = {}) {
    return loginAxios.post(
      `${window.location.origin}?c=Port&m=Web_Port&module=Set_user&opt=login`,
      { ...body, open_id: store.state.openId, code: store.state.code }
    );
  },
};
